import { render } from "./CarTypeBrandList.vue?vue&type=template&id=32f77236&scoped=true"
import script from "./CarTypeBrandList.vue?vue&type=script&lang=js"
export * from "./CarTypeBrandList.vue?vue&type=script&lang=js"

import "./CarTypeBrandList.vue?vue&type=style&index=0&id=32f77236&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32f77236"]])

export default __exports__